<template>
  <div class="fullscrean text-center">
    <img src="../assets/logo.png" alt="CCB" style="width: 150px">
    <div class="mt-4">
      <h6 class="mb-1">Lamentamos o inconveniente</h6>
      <p>Este app não está disponíveis no momento</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "StatusRegional",
  }
</script>

<style scoped>
  .fullscrean {
    position: absolute;
    width: 95%;
    top: 35%;
    left: 50%;
    transform: translateX(-50%);
  }
</style>
